<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      cell-class-name="align-top"
      resizable
      show-footer
      :footer-method="footerMethod"
      :checkbox-config="{ trigger: 'row', highlight: true, reserve: true }"
      row-id="amzSkuCode"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:ctnQty="{ row }">
        <span>{{ $l('form_label_ctnQty') }}: {{ row.ctnQty }}</span>
        <br />
        <span class="font-weight-bolder"
          >{{ $l('form_label_estimatedAvailable') }}:
          {{ row.estimatedAvailable }}</span
        >
        <br />
        <span
          >{{ $l('form_label_estimatedDelivery') }}:
          {{ row.estimatedDelivery }}</span
        >
        <br />
        <span
          >{{ $l('form_label_estimatedStock') }}: {{ row.estimatedStock }}</span
        >
      </template>
      <template v-slot:ftyInvQty="{ row }">
        <span>{{ $l('form_label_ctnQty') }}: {{ row.ftyInvQty }}</span>
        <br />
        <span class="font-weight-bolder"
          >{{ $l('form_label_estimatedAvailable') }}:
          {{ row.estimatedFtyAvailable }}</span
        >
        <br />
        <span
          >{{ $l('form_label_estimatedDelivery') }}:
          {{ row.estimatedFtyDelivery }}</span
        >
        <br />
        <span
          >{{ $l('form_label_estimatedStock') }}:
          {{ row.estimatedFtyStock }}</span
        >
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>SKU：</span><span style="color: #303133">{{ row.amzSkuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:displayScmName="{ row }">
        <span>NC：</span><span style="color: #303133">{{ row.ncNo }}</span>
        <br />
        <span>{{ row.scmName }}</span>
        <br />
        <span>LEAD TIME：</span
        ><span style="color: #409EFF">{{ row.ftyLeadTime }} </span>
        <span>{{ row.ftyLeadTime ? 'days' : '' }}</span>
        <br />
        <span>BUYER：</span
        ><span style="color: #303133">{{ row.buyerName }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return []
      if (this.tableData.length <= 0) return []
      const sumData = this.tableData[0].sumData

      let footerRow = [
        this.$l('INDEX.total') || '合计',
        '',
        '',
        '',
        '',
        '',
        '',
        sumData.sumCtnQty,
        sumData.sumFtyInvQty,
        sumData.sumFtyInvAmount,
      ]
      return [footerRow]
    },
  },
  methods: {
    footerMethod() {
      return this.footerData
    },
    
    removeCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
  },
}
</script>
